import { LoaderContainer } from './styles';

const Loader = () => <LoaderContainer />;

export default Loader;
